module.exports = __webpack_public_path__ + "static/img/2.b180a29.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/4/sp/2.png
// module id = C90e
// module chunks = 0